import { Injectable } from '@angular/core';

import { HttpContext, HttpCustomError, HttpResultProvider } from './http-result.provider';

/**
 * service responsible for providing the result's custom errors be used by the various http requests
 */
@Injectable()
export class DefaultHttpResultProvider implements HttpResultProvider {
    private customErrorsMap: any = {
        DEFAULT: {
            errorMessage: 'service unavailable',
        },
        QUEUE_SERVICE_UNAVAILABLE: {
            errorMessage: 'queue service unavailable',
        },
        SERVICE_ERRORS: {
            errorMessage: 'service errors',
        }
    };

    getResultFromKey(resultKey: string): any {
        if (resultKey && resultKey !== '') {
            for (const [key, value] of Object.entries(this.customErrorsMap)) {
                if (key === resultKey) {
                    return value;
                }
            }
        }
    
        return null;
    }

    getCustomErrorFromContext(context: HttpContext): HttpCustomError {
        if (context && context?.error) {
            return {
                error: context.error,
                key: 'SERVICE_ERRORS',
                statusCode: context.statusCode
            };
        }

        if (context && context?.serviceUrl && context?.statusCode) {
            // TODO add custom keys based on pair (url, status code) to allow different messages per service's status code
            // for now assume all errors come from queue

            return {
                key: 'QUEUE_SERVICE_UNAVAILABLE',
                statusCode: context.statusCode
            };
        }

        return { 
            key: 'DEFAULT',
            statusCode: 500
        };
    }
}